import {FormattedDate} from "../../DesignSystem/Moment/FormattedDate";
import React from "react";


export const FooterSidebar = ({user}) => {

    const showExpiryMessage = () => {
        if (user.companyPlan.companySubscriptionState === 'TRIAL_EXPIRED') {
            return <span style={{color: "white", paddingRight: "10px", verticalAlign: "middle"}}>Your free trial ended on <FormattedDate value={user.companyPlan.currentPeriodEnd}/></span>
        } else if (user.companyPlan.type === 'FREE_TRIAL') {
            return <span style={{paddingRight: "10px", verticalAlign: "middle", fontSize: '10px'}}>
                Your free trial will end on <FormattedDate value={user.companyPlan.currentPeriodEnd}/></span>
        } else {
            return <></>
        }
    }

    return <div style={{position: 'absolute', textAlign: 'center', bottom: 0, width: '100%', padding: '10px', background: '#f0f0f0'}}>
        {showExpiryMessage()}
    </div>

}